<template>
  <div class="userindex">
    <div class="mark" v-if="isFooterShow" @click="cancelMark"></div>
    <div class="van-content">
      <van-popup  v-model="newCont"  class="new-popup">
        <div class="hintbox">
          <div class="hintclear" @click="close()"><img src="/static/images/adventures-clear.png"/></div>
          <!--<h3 class="title"></h3>-->
          <div class="hintcent" v-html="newdatas">{{newdatas}}</div>
          <div class="newclose" >
            <van-button size="normal" class="theme-bg " @click="close()" >我知道了</van-button>
          </div>
        </div>
      </van-popup>
      <div class="userbanner" style="background-image: url('/static/images/bg1.png');background-size: 100% 100%;margin-bottom: 8px">
        <div class="userbanner-title"></div>
        <!-- <div class="user-icon" @click="userOperation">
          <img src="/static/images/user-icon.png" alt="">
        </div> -->
        <div class="userbox">
          <!-- <div></div> -->
          <div style="display: flex;align-items: center;margin-left: 16px;">
            <router-link to="">
              <img :src="this.$store.state.userCount.user_icon==null?'/static/images/headrimg.png':this.$store.state.userCount.user_icon" onerror="src='/static/images/headrimg.png'"/>
            </router-link>
            <!--<div v-if="point!=''" >-->
            <div style="width:140px;text-align: left;margin-left: 5px;">
              <p style="margin-top: 8px"><span style="color: #fff;font-size: 15px;" class="name" v-html="setuserName" ></span></p>
              <p class="vipjif" style="font-size:12px">集团积分</p>
              <p class="vipjif" style="font-size:10px;margin-top: 0;">(每年12月1日24:00清零)</p>
              <p class="vipjif" style="font-size:30px;margin-top: 0;">{{ this.$store.state.userCount.bloc_points_usable }}</p>
            </div>
            <div style="text-align: left;margin-left: 6px;">
              <p style="margin-top: 36px"><span style="color: #fff;font-size: 15px;" class="name"></span></p>
              <p class="vipjif" style="font-size:12px">工会积分:</p>
              <p class="vipjif" style="font-size:10px;margin-top: 0;">(永久有效)</p>
              <p class="vipjif" style="font-size:30px;margin-top: 0;">{{ this.$store.state.userCount.union_points_usable }}</p>
            </div>
          </div>
        </div>
      </div>
      <van-cell-group >
        <van-row>
          <van-col v-for="(items,index) in  httpss" :key="items.id"   span="6">
            <div @click="go(items.link,items.member_status,items.link_status,items.name)">
              <!-- <img src="/static/images/item-icon.png" /> -->
              <img :src="items.img == null?'/static/images/userpage6.png':items.img" onerror="src='/static/images/userheaderimg.png'"/>
              <p>{{items.name}}</p>
            </div>
          </van-col>
          <van-col span="6">
            <div @click="login()">
              <img src="/static/images/loginrenzhen.png" />
              <p>修改密码</p>
            </div>
          </van-col>
        </van-row>

      </van-cell-group>
    </div>
    <div class="footer-show" v-if="isFooterShow">
      <div @click="bindingMobile">绑定手机号</div>
      <div @click="amendPassword">密码修改</div>
      <div @click="cancel">取消</div>
    </div>
    <!--底部导航-->
    <!--<footer-nav></footer-nav>-->
  </div>
</template>

<script>
  import FooterNav from '@/components/footernav'
  import Login from '@/pages/login/index'
  import store from '../vuex/store'
  import Bus from '../../static/js/bus.js'
  import { Dialog } from 'vant';
  export default {
    name: "index",
    components: {
      FooterNav
    },
    store,
    props:['configData'],
    data () {
      return {
        newdatas:'',
        httpss:'',
        newCont:false,
        isFooterShow: false
      }
    },
    computed:{
      setuserName(){
        let username=this.$store.state.userCount.name==null?'未设置昵称':this.$store.state.userCount.name
        username+=this.$store.state.userCount.type==1?'<span style="font-size:12px;">(工会会员)<span>':'<span style="font-size:12px">(集团会员)<span>'
        return username
      }
    },
    methods:{
      goBack: function () {
        history.back(-1);
      },
      close(){
          this.newCont=false
      },
      onClickRight() {
        this.$router.push({ name: 'Personal' })
      },
      getHttp:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Nav/index', {}, res => {
          this.httpss = res.data.data
        })
      },
      go:function (a ,b ,c ,d) {
        console.log(a, b, c, d)
        var isUser = localStorage.getItem("BLHuser")
        console.log(isUser)
        this.$api.post('WebApi/Login/Index/select_login', {token:isUser}, res => {
          if(res.data.errCode == '0000'){
              if(c==0){
                var reg='http://'+this.host+'/'
//              var reg = new RegExp("http://www.bose.com");
                var str = a.replace(reg,"");
                console.log(str)
                this.$router.push({path:str})
              }else{
                if(a==''){
                  var str="暂无"+d+"，敬请期待!"
                  this.$toast(str);
                }else{
                  window.location.href = a;
                }
              }
          }else{
            if(b==0){
              if(c==0){
                var reg='http://'+this.host+'/'
//              var reg = new RegExp("http://www.bose.com");
                var str = a.replace(reg,"");
                this.$router.push({path:str})
              }else{
                if(a==''){
                  var str="暂无"+d+"，敬请期待!"
                  this.$toast(str);
                }else{
                  window.location.href = a;
                }
              }
            }else{
              Dialog.confirm({
                title: '提示 ',
                message: '请先登录认证'
              }).then(() => {
                this.$router.push({ name: 'Login' })
              }).catch(() => {
              });
            }
          }
        })
      },
      login:function () {
        this.isFooterShow = !this.isFooterShow
        // var isUser = localStorage.getItem("BLHuser")
        // this.$api.post('WebApi/Login/Index/select_login', {token:isUser}, res => {
        //   if(res.data.errCode == '0000'){
        //   this.$toast("您已登录认证");
          
        //   }else{
        //     this.$router.push({path:'/login'})
        //   }
        // })
      },
      getUser:function(){
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Info/index', {token:isUser}, res => {
            if(res.data.errCode == '0000'){
              this.userConfig = res.data.data.memberinfo;
              this.$store.commit('userinfo')
              console.log('000000', this.userConfig.reset_password)
              if(!this.userConfig.mobile) {
                Dialog.alert({
                  title: '提示 ',
                  message: '请先绑定手机号'
                }).then(() => {
                  this.$router.push({ name: 'BindMobile' })
                })
                return
              }
              if(this.userConfig.reset_password == 0) {
                console.log(23131231312321)
                Dialog.alert({
                  title: '提示 ',
                  message: '为了保障您的账户安全，首次登录时，您需要进行密码重置操作。'
                }).then(() => {
                  this.$router.push({ name: 'Password' })
                })
              }
              this.getRead();
            }else if(res.data.errCode == '0002'){
              Dialog.alert({
                title: '提示 ',
                message: '用户已停用，请联系管理员！'
              }).then(() => {
                WeixinJSBridge.call('closeWindow');
              })
            }else{
              this.$router.push({ name: 'Login' })
              document.body.removeChild(document.getElementById('Loading'))
              // window.location.href = root + '/WebApi/Index/Index/weixinlogin?redirect=' + window.location.href;
            }

        })
      },
      cancelMark() {
        this.isFooterShow = !this.isFooterShow
      },
      // 绑定手机号
      bindingMobile() {
        this.$router.push({ path: '/user/personal/mobile' })
      },
      // 密码修改
      amendPassword() {
        this.$router.push({ path: '/user/personal/password' })
      },
      cancel() {
        this.isFooterShow = !this.isFooterShow
      }
    },
    mounted () {
      this.host = window.location.host
      this.getHttp()
      this.getUser()
      console.log(4444444)
      var vm = this
      Bus.$on('notice', function (data) {
          if(data!=''){
            vm.newCont=true
            vm.newdatas = data
          }
      })
    },

  }
</script>

<style lang="less" scoped>
  .userindex{
    .van-content{
      padding-top: 0;
      /*消息弹框*/
      .new-popup{
        background-color: inherit;
        width: 80%;
        border-radius:12px;
        .hintbox{
          position: relative;
          border-radius: 12px;
          .title{
            padding-top: 10px;
            border-radius: 12px 12px 0 0;
            text-align: center;
            font-size: 1.4rem;
            background: #fff;
          }
          .hintclear{
            img{
              width: 22px;
            }
            position: absolute;
            right: -15px;
            top: -30px;
          }
          .hinttit{
            font-size: 18px;
            text-align: center;
            padding: 15px 0;
          }
          .newclose{
            text-align: center;padding: 15px 0;background: #fff;border-radius:0  0 12px 12px;
            button{
              width: 40%;
              border-radius: 6px;
            }
          }
          .hintcent{
            background-color: #fff;
            border-radius: 12px 12px 0 0;
            padding: 15px 30px;
            height: 250px;
            overflow-y: auto;
            color: #666;
            font-size: 1.2rem;
            .van-button{
              height: 40px;
              padding: 0 40px;
              border-radius: 20px;
              /*margin-top: 20px;*/
              font-size: 16px;
              background: #fe2b3c;
              border: none;
              color: #fff!important;
              box-shadow: 0px 4px 30px #fe2b3c;
            }
          }
        }
        .userlist{
          padding: 3.5px 30px;
        }
      }
      /*弹框结束*/
    }
    .userbanner{
      height: 226px;
      position: relative;
      .userbanner-title{
        position: absolute;
        top: 20px;
        left: 18px;
        width: 195px;
        height: 70px;
        background: url(/static/images/boxbanner-title.png);
        background-size: 100% 100%;
      }
      .userbox{
        text-align: center;
        background: url(/static/images/user-boxbg.png);
        background-size: 100% 100%;
        width: 95vw;
        height: 139px;
        position: absolute;
        bottom: 0px;
        left: calc(50% - 47.5vw);
        display: flex;
        justify-content: space-between;
        .vipname{
          background: #fb4141;
          padding: 4px 6px;
          border-radius: 6px;
          margin-right: 7px;
        }
        .name{
          font-size: 2rem;
        }
        .vipjif{
          margin-top: 8px;
          font-size: 1.6rem;
          color: #fff;
        }
        img{
          width: 100px;
          height: 100px;
          vertical-align: top;
          margin-right: 5px;
          border-radius: 50%;
        }
        .userInfo{
          display: inline-block;
          padding-top: 9px;
          p{
            color: #fff;
          }
        }
        .userInfo.will{
          padding-top: 0px;
          display: inline-block;
          p{
            color: #fff;
          }
        }
      }
      .signintag{
        background: #fa2924;
        width: 60px;
        display: inline-block;
        position: absolute;
        z-index: 1;
        right: 0;
        margin-top: 40px;
        overflow: hidden;
        border-radius: 16px 0 0 16px;
        box-shadow: 0px 1px 6px -1px #333;
      }

    }
    .van-cell:not(:last-child)::after{
      left: 0;
    }
    .userOrder{
      position: relative;
    }
    .van-cell-group,.van-cell{
      background: #fff;
    }
    .ordercell{
      img{
        width: 25px;
        height: auto;
        margin-bottom: 5px;
      }
    }
    .van-cell-group{
      .van-cell__title{
        img{
          width: 30px;
          margin-right: 5px;
        }
      }
    }
    .tell{
      vertical-align: -webkit-baseline-middle;
    }
    .van-row{
      padding: 0 1.86vw;
    }
    .van-col--6 {
      text-align: center;
      height: 36.36vw;
      width: 45.45vw;
      margin: 0 0.93vw;
      background-color: #fff;
      background: linear-gradient(180deg, #F2F2F2 0%, #FFFFFF 100%);
      border-radius: 13px;
      margin-bottom: 9px;
      position: relative;
      overflow: hidden;
      p{
        text-align: center!important;
        width: 70px;
        position: absolute;
        left: 50%;
        margin-left: -35px;
        margin-top: 10px;
      }
    }
    .van-col--6 img{
      width: 100%;
      height: 25vw;
    }

    .van-cell-group {
      margin-bottom: 0px;
      border-bottom: 1px solid #EEEEEE;
      background: #F2F2F2;
    }
    @media screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2){
      .van-col--6 {
        padding: 3%;
      }
    }
  }
  .user-icon {
    width: 22px;
    height: 22px;
    position: absolute;
    right: 18px;
    top: 27px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .footer-show {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 9999;
    div {
      background-color: #fff;
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 16px 0; 
      border: 1px solid ;
      border: none;
    }
  }
  .mark {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, .5);
    z-index: 6;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue